import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators, ValidationErrors, AbstractControl, ValidatorFn } from '@angular/forms';
import { ITrainingProgram } from '../../../models/training/training-program';
import { IPracticumSiteOregon } from 'app/models/training/practicum-site-oregon';
import { Observable, of, timer, switchMap, map, catchError } from 'rxjs';
import { WorkerPermitService } from 'app/services/licenses/worker.service';
import { SharedService } from 'app/services/core/shared.service';

@Component({
    selector: 'app-add-oregon-training-modal',
    templateUrl: './add-oregon-training-modal.component.html',
    styleUrls: ['./add-oregon-training-modal.component.scss'],
    standalone: false
})
export class AddOregonTrainingModalComponent implements OnInit {

  public trainingForm = new UntypedFormGroup({
    trainingProgramId: new UntypedFormControl('', [Validators.required]),
    supervisor: new UntypedFormControl('', [Validators.required, Validators.maxLength(100)]),
    supervisorFrom: new UntypedFormControl(''),
    workerPermitNumber: new UntypedFormControl('', [this.workerPermitNumberRequiredValidator()], [this.validateWorkerPermitNumber.bind(this)])
  });

  public trainingPrograms: ITrainingProgram[] = [];
  public editMode: boolean = false;

  constructor(
    public sharedService: SharedService,
    public dialogRef: MatDialogRef<AddOregonTrainingModalComponent>,
    public workerService: WorkerPermitService,
    @Inject(MAT_DIALOG_DATA) public data: {
      trainingPrograms: ITrainingProgram[],
      editMode?: boolean,
      existingProgram?: ITrainingProgram,
      existingSite?: IPracticumSiteOregon
    }
  ) {
    this.trainingPrograms = data.trainingPrograms;
    this.editMode = data.editMode || false;

    if (this.editMode && data.existingSite) {
      this.trainingForm.patchValue({
        trainingProgramId: data.existingSite.trainingProgramId,
        supervisor: data.existingSite.supervisor,
        supervisorFrom: data.existingSite.supervisorFrom,
        programName: data.existingSite.programName,
        workerPermitNumber: data.existingSite.workerPermitNumber
      });
      // Disable program selection in edit mode
      this.trainingForm.get('trainingProgramId').disable();
    }
    if(this.sharedService.isAfterJan15th2027()) {
      this.trainingForm.get('supervisor').disable();
    }
  }

  private workerPermitNumberRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!this.sharedService.isAfterJan15th2027()) {
        return null;
      }
      return Validators.required(control);
    };
  }

  private validateWorkerPermitNumber(control: AbstractControl): Observable<ValidationErrors | null> {
    const permitNumber = control.value;
    if (!permitNumber) {
      return of(null);
    }

    return timer(500).pipe(
      switchMap(() => this.workerService.getWorkerPermitName(permitNumber)),
      map(permitName => {
        this.trainingForm.get('supervisor').setValue(permitName || '', { emitEvent: false });
        return permitName ? null : { permitNotFound: true };
      }),
      catchError(() => {
        this.trainingForm.get('supervisor').setValue('', { emitEvent: false });
        return of({ permitNotFound: true });
      })
    );
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.trainingForm.pending) {
      return;
    }
    if (this.trainingForm.valid || this.editMode) {
      const result: IPracticumSiteOregon = {
        id: this.editMode ? this.data.existingSite.id : 0,
        trainingProgramId: this.editMode ? this.data.existingSite.trainingProgramId : this.trainingForm.get('trainingProgramId').value,
        supervisor: this.trainingForm.get('supervisor').value,
        supervisorFrom: this.trainingForm.get('supervisorFrom').value,
        workerPermitNumber: this.trainingForm.get('workerPermitNumber').value,
        archived: false,
        trainingProgramName: '',
        programId: '',
        trainingProgramApproved: true
      };
      this.dialogRef.close(result);
    }
  }
}
